import { render } from "./AndroidUpdate.vue?vue&type=template&id=1026c266"
import script from "./AndroidUpdate.vue?vue&type=script&lang=js"
export * from "./AndroidUpdate.vue?vue&type=script&lang=js"

import "./AndroidUpdate.vue?vue&type=style&index=0&id=1026c266&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__